import { Pencil, GripVertical, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MemberAvatar } from "@/components/MemberAvatar";
import { recurrenceLabel } from "@/lib/recurrence";
import { cn } from "@/lib/utils";

export function lastDoneLabel(iso) {
  if (!iso) return "Never done";
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days <= 0) return "Done today";
  if (days === 1) return "Done yesterday";
  return `Done ${days}d ago`;
}

export function CleaningCard({ task, assignees, dp, snapshot, onComplete, onEdit }) {
  return (
    <div
      ref={dp.innerRef}
      {...dp.draggableProps}
      data-testid={`cleaning-card-${task.id}`}
      className={cn("bento-tile flex items-center gap-3 p-4", snapshot.isDragging && "ring-2 ring-primary")}
    >
      <span {...dp.dragHandleProps} className="cursor-grab text-muted-foreground/60">
        <GripVertical className="h-5 w-5" />
      </span>
      <button
        onClick={() => onComplete(task)}
        data-testid={`cleaning-complete-${task.id}`}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-border text-transparent transition-all hover:border-mint hover:text-mint bento-pressable"
      >
        <Check className="h-5 w-5" strokeWidth={3} />
      </button>
      <div className="min-w-0 flex-1">
        <p className="truncate font-display font-semibold text-ink">{task.title}</p>
        <div className="mt-0.5 flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground">
          <span>{recurrenceLabel(task)}</span>
          <span>· {lastDoneLabel(task.last_done)}</span>
        </div>
      </div>
      <div className="flex -space-x-2">
        {assignees.slice(0, 3).map((m) => (
          <MemberAvatar key={m.id} member={m} size="sm" />
        ))}
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 rounded-full"
        onClick={() => onEdit(task)}
        data-testid={`cleaning-edit-${task.id}`}
      >
        <Pencil className="h-4 w-4" />
      </Button>
    </div>
  );
}
